import {
    Box, Container, Stack, Typography, Card, CardContent, CardActions, Button, Chip, Dialog,
    DialogActions, Tooltip, Alert,
    DialogContent,
    DialogTitle,
    TextField,
    Snackbar,
} from "@mui/material";
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import {messages} from "./config/messages";
import {USER_ACTIONS, isAllowedAction} from "./config/auth";
import ParticipantListOfConnectors from "./formViews/ParticipantListOfConnectors";
import ParticipantDetailsDialog from "./participants/ParticipantDetailsDialog";
import {PARTICIPANT_CONNECTORS, PARTICIPANT_FORM_SUBMITION, PARTICIPANT_REQUEST_STATUS_CHANGE_API, PARTICIPANT_FORM_SCHEMA} from "./config/settings";
import Grid from '@mui/material/Grid2';
import {parseErrorData} from "./config/commonFunctions";
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import HubIcon from '@mui/icons-material/Hub';

export default function HomePage() {
    const navigate = useNavigate();
    const [connectors, setConnectors] = useState([]);
    const [schemaAsObject, setSchemaAsObject] = useState({});
    const [participant, setParticipant] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [dialogSuspendOpen, setDialogSuspendOpen] = useState(false);
    const [dialogUnSuspendOpen, setDialogUnSuspendOpen] = useState(false);
    const [dialogWithdrawOpen, setDialogWithdrawOpen] = useState(false);
    const [suspendReason, setSuspendReason] = useState("");
    const [unSuspendReason, setUnSuspendReason] = useState("");
    const [withdrawReason, setWithdrawReason] = useState("");
    const [anchorEl, setAnchorEl] = useState(null);
    const [detailsDialogOpen, setDetailsDialogOpen] = useState(false);
    const [selectedParticipantObj, setSelectedParticipantObj] = useState(null);
    // Snackbar state
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState("success");

    const language = "en";


    const fetchSchema = async () => {
        const url = PARTICIPANT_FORM_SCHEMA + language + "/";
        const response = await axios.get(url);
        setSchemaAsObject(response.data);
        // console.log("Fetched Schema:", response.data);
      };

    const handleViewClick = (participant) => {
        // console.log(participant);
        setSelectedParticipantObj(participant); // Store the entire participant object
        setDetailsDialogOpen(true);
      };

      const handleDetailsDialogClose = () => {
        setDetailsDialogOpen(false);
      };

    const handleClose = () => {
        setAnchorEl(null);
      };

    const handleSuspend = () => {
        setDialogSuspendOpen(true);
        handleClose();
      };

      const handleUnSuspend = () => {
        setDialogUnSuspendOpen(true);
        handleClose();
      };

      const handleDialogSuspendClose = () => {
        setDialogSuspendOpen(false);
        setSuspendReason(""); // Clear the reason input
      };

      const handleDialogUnSuspendClose = () => {
        setDialogUnSuspendOpen(false);
        setUnSuspendReason(""); // Clear the reason input
      };
      const handleWithdraw = () => {
        setDialogWithdrawOpen(true);
        handleClose();
      };

      const handleDialogWithdrawClose = () => {
        setDialogWithdrawOpen(false);
        setWithdrawReason(""); // Clear the reason input
      };

      const handleSnackbarClose = (event, reason) => {
        if (reason === "clickaway") {
          return;
        }
        setSnackbarOpen(false);
      };

    useEffect(() => {
        fetchConnectors();
        {isAllowedAction(USER_ACTIONS.UPDATE_OWN_CONNECTOR) && fetchSchema();}
        {(isAllowedAction(USER_ACTIONS.UPDATE_OWN_FORM) || isAllowedAction(USER_ACTIONS.UPDATE_OWN_CONNECTOR)) && fetchParticipants();}
      }, []);

    const fetchParticipants = async () => {
        try {
            const response = await axios.get(PARTICIPANT_FORM_SUBMITION);
            setParticipant(response.data[0]);
            // console.log("Fetched Participants:", response.data[0]);
            setLoading(false);
        } catch (err) {
            setError(err);
            setLoading(false);
        }
    };

    const fetchConnectors = async () => {
        try {
          const response = await axios.get(PARTICIPANT_CONNECTORS);
          setConnectors(response.data);
          // console.log(response.data);
          setLoading(false);
        } catch (err) {
          setError(err);
          setLoading(false);
        }
      };
      const handleSubmitSuspend = async () => {
        try {
          const payload = {
            participantID: participant.id,
            reason: suspendReason,
            requested_status: "suspension",
          };
          await axios.put(PARTICIPANT_REQUEST_STATUS_CHANGE_API, payload);
          setDialogSuspendOpen(false);
          await fetchParticipants();
          setSnackbarMessage("Participant suspended successfully!");
          setSnackbarSeverity("success");
          setSnackbarOpen(true);
          handleClose();
        } catch (err) {
          console.error("Error during suspending:", err);
          const errorMessage =
            parseErrorData(err.response?.data) || "Failed to suspend participant.";
          setSnackbarMessage(errorMessage);
          setSnackbarSeverity("error");
          setSnackbarOpen(true); // Show snackbar on error
        }
      };

      const handleSubmitUnSuspend = async () => {
        try {
          const payload = {
            participantID: participant.id,
            reason: unSuspendReason,
            requested_status: "undo suspension",
          };
          await axios.put(PARTICIPANT_REQUEST_STATUS_CHANGE_API, payload);
          setDialogUnSuspendOpen(false);
          await fetchParticipants();
          setSnackbarMessage(messages.registryHomeSubmitUnSuspendSuccess);
          setSnackbarSeverity("success");
          setSnackbarOpen(true);
          handleClose();
        } catch (err) {
          console.error("Error during unsuspending:", err);
          const errorMessage =
            parseErrorData(err.response?.data) || messages.registryHomeSubmitUnSuspendError;
          setSnackbarMessage(errorMessage);
          setSnackbarSeverity("error");
          setSnackbarOpen(true); // Show snackbar on error
        }
      };

      const handleSubmitWithdraw = async () => {
        try {
          const payload = {
            participantID: participant.id,
            reason: withdrawReason,
            requested_status: "withdrawal",
          };
          await axios.put(PARTICIPANT_REQUEST_STATUS_CHANGE_API, payload);
          setDialogWithdrawOpen(false);
          await fetchParticipants();
          setSnackbarMessage(messages.registryHomeRequestTerminationSnackbarSuccess);
          setSnackbarSeverity("success");
          setSnackbarOpen(true);
        } catch (err) {
          console.error("Error during terminating:", err);
          const errorMessage =
            parseErrorData(err.response?.data) || messages.registryHomeRequestTerminationSnackbarError;
          setSnackbarMessage(errorMessage);
          setSnackbarSeverity("error");
          setSnackbarOpen(true); // Show snackbar on error
        }
      };

    // console.log(participant);
    return (
        <Container sx={{ mt: 5, mb: 8 }} maxWidth="lg">
            <Box sx={{ position: "relative" }}>
                <Stack sx={{ mb: 2, mt: 1 }}>
                    <div className="background-shape text-center">
                        {isAllowedAction(USER_ACTIONS.ADMINISTER_PARTICIPANT_REGISTRY) && <>
                            <Typography variant="h3" sx={{ mb: 1, mt: 5 }}>{messages.registryHomeAdminTitle}</Typography>
                            {isAllowedAction(USER_ACTIONS.ADMINISTER_PARTICIPANT_REGISTRY) && <Typography color="textSecondary" variant="h5" sx={{ mb: 3, mt: 1 }}>
                                {messages.registryHomeAdminSubTitle}
                            </Typography>}
                            {isAllowedAction(USER_ACTIONS.VIEW_PARTICIPANT_REGISTRY) && <Typography variant="h5" color="textSecondary" sx={{ mb: 3, mt: 1 }}>
                                {messages.registryHomeGBMemberSubTitle}
                            </Typography>}
                        </>
                        }
                        {isAllowedAction(USER_ACTIONS.UPDATE_OWN_FORM) && <>
                        <Typography variant="h4" sx={{ mb: 1, mt: 5 }}>{messages.registryHomeUserTitle}</Typography>
                        <Typography variant="h5" sx={{ mb: 3, mt: 1 }} color="textSecondary">
                            {messages.registryHomeUserSubTitle}
                        </Typography>
                        </>
                        }
                    </div>
                </Stack>
                <Grid container spacing={{ xs: 2, md: 2 }} alignItems="stretch">
                {(isAllowedAction(USER_ACTIONS.UPDATE_OWN_CONNECTOR)) &&  <Grid style={{ display: "flex" }} size={{xs: 12, sm: 4}}>
                        <Card sx={{
                            display: "flex", justifyContent: "space-between", flexDirection: "column",
                            width: "100%", position: "relative", zIndex: "0", borderRadius: 4,
                            boxShadow: 3,
                            transition: "0.3s",
                            "&:hover": {
                                boxShadow: 6,
                                transform: "scale(1.02)",
                                backgroundColor: "#eef2f6",
                            },
                        }}>
                            <CardContent sx={{ color: "#213270" }}>
                                <HubIcon sx={{ fontSize: 40, color: "primary.main", mb: 1 }} />
                                <Typography variant="h4" gutterBottom>
                                {messages.registryHomeConnectorCreationTitle}
                                </Typography>
                                <Typography variant="h5" color="textSecondary">{messages.registryHomeConnectorCreationSubTitle}</Typography>
                                <Box className="rounded-box-blue-light"></Box>
                            </CardContent>
                            <CardActions>
                                <div style={{ display: "flex", gap: "1em", flexWrap: "nowrap" }}>
                                    <div>
                                        <Button disabled={participant?.management?.approval_status === "WITHDRAWN" || participant?.management?.approval_status === "SUSPENDED"} variant="contained" component={Link} to="/connector-form" color="info" size="small">
                                            {messages.registryHomeNewConnectorButton}
                                        </Button>
                                    </div>
                                </div>
                            </CardActions>
                        </Card>
                    </Grid>}
                    <Grid style={{ display: "flex" }} size={{xs: 12, sm: isAllowedAction(USER_ACTIONS.UPDATE_OWN_FORM) ? 8 : 6}}>
                        <Card sx={{
                            display: "flex", justifyContent: "space-between", flexDirection: "column",
                            width: "100%", position: "relative", zIndex: "0",
                            boxShadow: 3,
                            transition: "0.3s",
                            "&:hover": {
                                boxShadow: 6,
                                transform: "scale(1.02)",
                                backgroundColor: "#eef2f6",
                            },
                        }}>
                            <CardContent sx={{ color: "#213270" }}>
                                <PeopleAltIcon sx={{ fontSize: 40, color: "primary.main", mb: 1 }} />
                                <Typography variant="h4" gutterBottom>
                                    {messages.registryHomeOverviewTitle}
                                </Typography>
                                {(isAllowedAction(USER_ACTIONS.ADMINISTER_PARTICIPANT_REGISTRY) || isAllowedAction(USER_ACTIONS.VIEW_PARTICIPANT_REGISTRY)) && <Typography variant="h5" color="textSecondary">{messages.registryHomeAdminCardSubTitle}</Typography>}
                                {isAllowedAction(USER_ACTIONS.UPDATE_OWN_FORM) && <Typography variant="h5" color="textSecondary">{messages.registryHomeParticipantCardSubTitle}</Typography>}
                                <Box sx={{ pt: 2 }}>
                                    {!loading && isAllowedAction(USER_ACTIONS.UPDATE_OWN_FORM) &&
                                        participant?.management?.approval_status &&
                                        participant?.management?.request_status === "NO_REQUEST" &&
                                        <div> <Chip label={participant?.management?.approval_status} color="secondary" size="small" variant="outlined" /> </div>
                                    }
                                </Box>
                                <Box sx={{ pt: 2 }}>
                                    {!loading && isAllowedAction(USER_ACTIONS.UPDATE_OWN_FORM) &&
                                        participant?.management?.request_status !== "NO_REQUEST" &&
                                        <div> <Chip label={participant?.management?.request_status} color="error" size="small" variant="outlined" /> </div>}
                                </Box>
                            </CardContent>
                            <CardActions>
                                <div style={{ display: "flex", gap: "1em", flexWrap: "nowrap" }}>
                                    {(isAllowedAction(USER_ACTIONS.ADMINISTER_PARTICIPANT_REGISTRY) || isAllowedAction(USER_ACTIONS.VIEW_PARTICIPANT_REGISTRY) )&& <div>
                                        <Button variant="contained" disabled={false} component={Link} to="/participant-list" color="primary">
                                            {messages.registryHomeAdminCardTitle}
                                        </Button>
                                    </div>}

                                    {!loading && isAllowedAction(USER_ACTIONS.UPDATE_OWN_CONNECTOR) &&
                                        // (participant?.management?.approval_status !== "WITHDRAWN" && participant?.management?.approval_status !== "SUSPENDED")  &&
                                        <div>
                                            <Button variant="contained"
                                                disabled={participant?.management?.approval_status === "WITHDRAWN" || participant?.management?.approval_status === "SUSPENDED"}
                                                color="info" size="small"  sx={{textAlign: "center"}}
                                                onClick={() => handleViewClick(participant)}>
                                                {messages.registryHomeViewButton}
                                            </Button>

                                            {detailsDialogOpen && participant?.id && (
                                                <ParticipantDetailsDialog
                                                    open={detailsDialogOpen}
                                                    onClose={handleDetailsDialogClose}
                                                    participant={participant}
                                                    // onEdit={handleEdit}
                                                    mappings={schemaAsObject.$defs}
                                                    schemaAsObject={schemaAsObject}
                                                />)}
                                        </div>}

                                        {!loading && isAllowedAction(USER_ACTIONS.UPDATE_OWN_FORM) &&
                                        // (participant?.management?.approval_status !== "WITHDRAWN" && participant?.management?.approval_status !== "SUSPENDED")  &&
                                        <div>
                                            <Button variant="contained" component={Link}
                                                to={participant ? `/participant-form/${participant.id}` : "#"}
                                                disabled={participant?.management?.approval_status === "WITHDRAWN" || participant?.management?.approval_status === "SUSPENDED"}
                                                state={participant ? { participant } : null}
                                                color="info" size="small"  sx={{textAlign: "center"}}>
                                                {messages.registryHomeEditButton}
                                            </Button>
                                        </div>}

                                    {!loading && isAllowedAction(USER_ACTIONS.UPDATE_OWN_FORM) &&
                                        // (participant?.management?.approval_status !== "WITHDRAWN" && participant?.management?.approval_status !== "SUSPENDED")  &&
                                        <div>
                                            <Button variant="contained" component={Link}
                                                to={participant ? `/participant-documents/${participant.id}` : "#"}
                                                disabled={participant?.management?.approval_status === "WITHDRAWN" || participant?.management?.approval_status === "SUSPENDED"}
                                                state={participant ? { participant } : null}
                                                color="info" size="small" sx={{textAlign: "center"}}>
                                                {messages.registryHomeEditDocumentsButton}
                                            </Button>
                                        </div>}
                                    {!loading && isAllowedAction(USER_ACTIONS.UPDATE_OWN_FORM) &&
                                        participant?.management?.approval_status === "APPROVED" &&
                                        <div>
                                            <Button onClick={() => handleWithdraw()} variant="contained"
                                                disabled={participant?.management?.request_status === "REQUESTED_WITHDRAWAL"}
                                                color="secondary" size="small">{messages.registryHomeRequestTerminationButton}
                                            </Button>
                                        </div>}
                                    {!loading && isAllowedAction(USER_ACTIONS.UPDATE_OWN_FORM) &&
                                        participant?.management?.approval_status === "APPROVED" &&
                                        // participant?.management?.request_status !== "REQUESTED_SUSPENSION" && participant?.management?.approval_status === "SUSPENDED"
                                        <div>
                                            <Button
                                                disabled={participant?.management?.request_status === "REQUESTED_SUSPENSION" || participant?.management?.approval_status === "SUSPENDED"}
                                                onClick={() => handleSuspend()} variant="contained" color="warning" size="small">
                                                {messages.registryHomeRequestSuspensionButton}
                                            </Button>
                                        </div>}
                                    {/* suspend Dialog */}
                                    <Dialog
                                        open={dialogSuspendOpen}
                                        onClose={handleDialogSuspendClose}
                                        maxWidth={"lg"}
                                    >
                                        <DialogTitle><Typography variant="h5" sx={{ fontWeight: 600 }}>{messages.registryHomeSuspendDialogTitle}</Typography></DialogTitle>
                                        <DialogContent>
                                            <Typography variant="body1">{messages.registryHomeSuspendDialogAsk}</Typography>
                                            <div style={{ paddingTop: "1em" }}>
                                                <TextField
                                                    label={messages.dialogTextFieldSuspendReason}
                                                    fullWidth
                                                    multiline
                                                    required
                                                    rows={3}
                                                    value={suspendReason}
                                                    onChange={(e) => setSuspendReason(e.target.value)}
                                                />
                                            </div>
                                        </DialogContent>
                                        <DialogActions>
                                            <Button onClick={handleDialogSuspendClose} color="primary" variant="outlined">
                                                {messages.cancel}
                                            </Button>
                                            <Tooltip title={suspendReason === "" ? "Please fill out all required fields" : ""} placement="top" arrow>
                                                <div><Button
                                                    onClick={handleSubmitSuspend}
                                                    color="primary"
                                                    variant="outlined"
                                                    disabled={suspendReason === ""}
                                                >
                                                    {messages.registryHomeSubmitSuspension}
                                                </Button>
                                                </div>
                                            </Tooltip>
                                        </DialogActions>
                                    </Dialog>
                                    {!loading && isAllowedAction(USER_ACTIONS.UPDATE_OWN_FORM) &&
                                        participant?.management?.approval_status === "SUSPENDED" &&
                                        <div>
                                            <Button
                                                disabled={participant?.management?.request_status === "REQUESTED_UNDO_SUSPENSION"}
                                                onClick={() => handleUnSuspend()} variant="contained" color="warning" size="small">
                                                {messages.registryHomeRequestUnSuspensionButton}
                                            </Button>
                                        </div>}
                                    {/* suspend Dialog */}
                                    <Dialog
                                        open={dialogUnSuspendOpen}
                                        onClose={handleDialogUnSuspendClose}
                                        maxWidth={"lg"}
                                    >
                                        <DialogTitle><Typography variant="h5" sx={{ fontWeight: 600 }}>{messages.registryHomeUnsuspendUser}</Typography></DialogTitle>
                                        <DialogContent>
                                            <Typography variant="body1">{messages.registryHomeUnsuspendUserAsk}</Typography>
                                            <div style={{ paddingTop: "1em" }}>
                                                <TextField
                                                    label={messages.dialogTextUnsuspensionReason}
                                                    fullWidth
                                                    multiline
                                                    required
                                                    rows={3}
                                                    value={unSuspendReason}
                                                    onChange={(e) => setUnSuspendReason(e.target.value)}
                                                />
                                            </div>
                                        </DialogContent>
                                        <DialogActions>
                                            <Button onClick={handleDialogUnSuspendClose} color="primary" variant="outlined">
                                                {messages.cancel}
                                            </Button>
                                            <Tooltip title={unSuspendReason === "" ? "Please fill out all required fields" : ""} placement="top" arrow>
                                                <div><Button
                                                    onClick={handleSubmitUnSuspend}
                                                    color="primary"
                                                    variant="outlined"
                                                    disabled={unSuspendReason === ""}
                                                >
                                                    {messages.registryHomeSubmitUnSuspension}
                                                </Button>
                                                </div>
                                            </Tooltip>
                                        </DialogActions>
                                    </Dialog>

                                    {/* withdraw Dialog */}
                                    <Dialog
                                        open={dialogWithdrawOpen}
                                        onClose={handleDialogWithdrawClose}
                                        maxWidth={"lg"}
                                    >
                                        <DialogTitle><Typography variant="h5" sx={{ fontWeight: 600 }}>{messages.registryHomeTerminateUser}</Typography></DialogTitle>
                                        <DialogContent>
                                            <Typography variant="body1">{messages.registryHomeTerminateUserAsk}</Typography>
                                            <div style={{ paddingTop: "1em" }}>
                                                <TextField
                                                    label={messages.dialogTextFielTerminateReason}
                                                    fullWidth
                                                    multiline
                                                    required
                                                    rows={3}
                                                    value={withdrawReason}
                                                    onChange={(e) => setWithdrawReason(e.target.value)}
                                                />
                                            </div>
                                        </DialogContent>
                                        <DialogActions>
                                            <Button onClick={handleDialogWithdrawClose} color="primary" variant="outlined">
                                                {messages.cancel}
                                            </Button>
                                            <Tooltip title={withdrawReason === "" ? "Please fill out all required fields" : ""} placement="top" arrow >
                                                <div>
                                                    <Button
                                                        onClick={handleSubmitWithdraw}
                                                        color="primary"
                                                        variant="outlined"
                                                        disabled={withdrawReason === ""}
                                                    >
                                                        {messages.registryHomeSubmitTermination}
                                                    </Button>
                                                </div>
                                            </Tooltip>
                                        </DialogActions>
                                    </Dialog>
                                </div>
                            </CardActions>
                        </Card>
                    </Grid>
                    {(isAllowedAction(USER_ACTIONS.ADMINISTER_PARTICIPANT_REGISTRY) ||
                        isAllowedAction(USER_ACTIONS.VIEW_PARTICIPANT_REGISTRY)) &&
                      <Grid style={{ display: "flex" }} size={{xs: 12, sm: 6}}>
                        <Card sx={{
                            display: "flex", justifyContent: "space-between", flexDirection: "column",
                            width: "100%", position: "relative", zIndex: "0",
                            boxShadow: 3,
                            transition: "0.3s",
                            "&:hover": {
                                boxShadow: 6,
                                transform: "scale(1.02)",
                                backgroundColor: "#eef2f6",
                            },
                        }}>
                            <CardContent sx={{ color: "#213270" }}>
                                <HubIcon sx={{ fontSize: 40, color: "primary.main", mb: 1 }} />
                                <Typography variant="h4" gutterBottom>
                                {messages.registryHomeConnectorViewTitle}
                                </Typography>
                                <Typography variant="h5" color="textSecondary">{messages.registryHomeConnectorViewSubTitle}</Typography>
                                <Box className="rounded-box-blue-light"></Box>
                            </CardContent>
                            <CardActions>
                                <div style={{ display: "flex", gap: "1em", flexWrap: "nowrap" }}>
                                    <div>
                                        <Button variant="contained" component={Link} to="/connector-list" color="primary">
                                           {messages.registryHomeConnectorViewbutton}
                                        </Button>
                                    </div>
                                </div>
                            </CardActions>
                        </Card>
                    </Grid> }
                </Grid>
                {(isAllowedAction(USER_ACTIONS.UPDATE_OWN_CONNECTOR) ||
                    isAllowedAction(USER_ACTIONS.UPDATE_OWN_FORM))
                    && <ParticipantListOfConnectors participant={participant} />}
            </Box>
            {/* Snackbar Component */}
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={handleSnackbarClose}
            >
                <Alert
                    onClose={handleSnackbarClose}
                    severity={snackbarSeverity}
                    sx={{ width: "100%" }}
                >
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </Container>
    );
}
